import { ApiResponse } from 'emma-common-ts';
import { map, Observable } from 'rxjs';

export function getResponseData<T>(obs: Observable<ApiResponse<T> | null>): Observable<T | undefined> {
  return obs.pipe(map((res) => res?.data));
}
